export default __webpack_public_path__ + "static/media/highlight-7.943cf32b.jpg";